import { api } from '../api';
import {
  AnalyticsQueryDto,
  PlayerMetricsDto,
  FinancialMetricsDto,
  GameHealthMetricsDto,
  RetentionCohortDto,
  FunnelMetricsDto,
  PlayerBehaviorMetricsDto,
  MarketingROIMetricsDto,
  AnalyticsSummaryDto,
} from './analytics-types';

const BASE_URL = '/v1/admin/analytics';

// Summary endpoint
export const getAnalyticsSummary = async (): Promise<AnalyticsSummaryDto> => {
  const response = await api.get<AnalyticsSummaryDto>(`${BASE_URL}/summary`);
  return response.data;
};

// Player metrics
export const getPlayerMetrics = async (query: AnalyticsQueryDto): Promise<PlayerMetricsDto> => {
  const response = await api.get<PlayerMetricsDto>(`${BASE_URL}/player-metrics`, { params: query });
  return response.data;
};

// Financial metrics
export const getFinancialMetrics = async (query: AnalyticsQueryDto): Promise<FinancialMetricsDto> => {
  const response = await api.get<FinancialMetricsDto>(`${BASE_URL}/financial-metrics`, { params: query });
  return response.data;
};

// Game health metrics
export const getGameHealthMetrics = async (query: AnalyticsQueryDto): Promise<GameHealthMetricsDto> => {
  const response = await api.get<GameHealthMetricsDto>(`${BASE_URL}/game-health-metrics`, { params: query });
  return response.data;
};

// Retention cohorts
export const getRetentionCohorts = async (query: AnalyticsQueryDto): Promise<RetentionCohortDto[]> => {
  const response = await api.get<RetentionCohortDto[]>(`${BASE_URL}/retention-cohorts`, { params: query });
  return response.data;
};

// Conversion funnel
export const getConversionFunnel = async (query: AnalyticsQueryDto): Promise<FunnelMetricsDto> => {
  const response = await api.get<FunnelMetricsDto>(`${BASE_URL}/conversion-funnel`, { params: query });
  return response.data;
};

// Player behavior metrics
export const getPlayerBehaviorMetrics = async (query: AnalyticsQueryDto): Promise<PlayerBehaviorMetricsDto> => {
  const response = await api.get<PlayerBehaviorMetricsDto>(`${BASE_URL}/player-behavior`, { params: query });
  return response.data;
};

// Marketing ROI metrics
export const getMarketingROI = async (query: AnalyticsQueryDto): Promise<MarketingROIMetricsDto> => {
  const response = await api.get<MarketingROIMetricsDto>(`${BASE_URL}/marketing-roi`, { params: query });
  return response.data;
};
